/** Dedicated frontend GA4 property (gtag.js). Independent of legacy G-V03TEP7J74 / GTM. */

/** Legacy property always configured in public/index.html — fallback for gtag id lookups. */
export const GA4_LEGACY_MEASUREMENT_ID = 'G-V03TEP7J74';

export const GA4_MEASUREMENT_ID_ENV = 'REACT_APP_GA4_MEASUREMENT_ID';
export const GA4_TRACKER_ENABLED_ENV = 'REACT_APP_GA4_TRACKER_ENABLED';

/**
 * Deployed environment name. Needed because NODE_ENV cannot distinguish
 * dev.cafezupas.com from production — `react-scripts build` reports
 * NODE_ENV=production for both.
 */
export const APP_ENV_ENV = 'REACT_APP_ENV';

/**
 * QA overrides for deployed non-production hosts, both ignored when
 * REACT_APP_ENV=production. See ga4Env.ts for why that refusal lives in code.
 */
export const GA4_DEBUG_MODE_ENV = 'REACT_APP_GA4_DEBUG_MODE';
export const GA4_FORCE_CONSENT_ENV = 'REACT_APP_GA4_FORCE_CONSENT';

/** Dev-only smoke event fired once after init to verify DebugView / collect requests. */
export const GA4_SETUP_TEST_EVENT = 'ga4_setup_test';
